export function createLibraryUiActionFacade(context = {}) {
  const {
    ensureBooklistModuleReady,
    ensureLibraryModalsModuleReady,
    ensureBookDetailModuleReady,
    ensureFileImportModuleReady,
    showToast
  } = context;

  const showError = (message) => {
    if (typeof showToast === 'function') {
      showToast(message);
    }
  };

  function showAddBooklistModal() {
    ensureBooklistModuleReady()
      .then((mod) => {
        mod?.showAddBooklistModal?.();
      })
      .catch(() => {
        showError('书单模块加载失败');
      });
  }

  function invokeLibraryModals(fnName, ...args) {
    ensureLibraryModalsModuleReady()
      .then((mod) => {
        const fn = mod?.[fnName];
        if (typeof fn === 'function') {
          fn(...args);
        }
      })
      .catch(() => {
        showError('管理模块加载失败');
      });
  }

  function showAllCategoriesModal() {
    invokeLibraryModals('showAllCategoriesModal');
  }

  function showAddCategoryModal() {
    invokeLibraryModals('showAddCategoryModal');
  }

  function showEditCategoryMenu(category, triggerBtn) {
    invokeLibraryModals('showEditCategoryMenu', category, triggerBtn);
  }

  function showAllBooklistsModal() {
    invokeLibraryModals('showAllBooklistsModal');
  }

  function showManageBooklistBooksModal(booklistId) {
    invokeLibraryModals('showManageBooklistBooksModal', booklistId);
  }

  function showEditBooklistMenu(booklistId, triggerBtn, options = {}) {
    invokeLibraryModals('showEditBooklistMenu', booklistId, triggerBtn, options);
  }

  function showAllCollectionsModal() {
    invokeLibraryModals('showAllCollectionsModal');
  }

  function showAddCollectionModal() {
    invokeLibraryModals('showAddCollectionModal');
  }

  function showEditCollectionMenu(collectionId, triggerBtn, options = {}) {
    invokeLibraryModals('showEditCollectionMenu', collectionId, triggerBtn, options);
  }

  function showBatchCollectionModal() {
    invokeLibraryModals('showBatchCollectionModal');
  }

  function showBookDetail(bookId) {
    ensureBookDetailModuleReady()
      .then((mod) => {
        mod?.showBookDetail?.(bookId);
      })
      .catch(() => {
        showError('详情模块加载失败');
      });
  }

  async function handleFileSelect(event) {
    try {
      const mod = await ensureFileImportModuleReady();
      await mod?.handleFileSelect?.(event);
    } catch {
      showError('导入模块加载失败');
    }
  }

  async function handleDrop(event) {
    try {
      const mod = await ensureFileImportModuleReady();
      await mod?.handleDrop?.(event);
    } catch {
      showError('导入模块加载失败');
    }
  }

  return {
    showAddBooklistModal,
    invokeLibraryModals,
    showAllCategoriesModal,
    showAddCategoryModal,
    showEditCategoryMenu,
    showAllBooklistsModal,
    showManageBooklistBooksModal,
    showEditBooklistMenu,
    showAllCollectionsModal,
    showAddCollectionModal,
    showEditCollectionMenu,
    showBatchCollectionModal,
    showBookDetail,
    handleFileSelect,
    handleDrop
  };
}
